import React from "react";
import "./bottom-nav.css";
import { animateScroll as scroll } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const BottomNavPanel = ({ switchTheme, theme }) => {
  let defaultTheme = localStorage.getItem("theme");

  const handleSwitchTheme = () => {
    if (theme === "light") {
      switchTheme("dark");
    } else {
      switchTheme("light");
    }
  };

  React.useEffect(() => {
    if (defaultTheme === null) {
      defaultTheme = "light";
    } else {
      switchTheme(defaultTheme);
    }
  }, []);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  const scrollToBottom = () => {
    scroll.scrollToBottom();
  }

  return (
    <div className="container">
      <div className="box">
        <i onClick={scrollToTop} className="fa-solid fa-house"></i>
      </div>
      <div className="box">
        <i onClick={handleSwitchTheme} className={`fa-solid ${theme === "light" ? "fa-moon" : "fa-sun"}`}></i>
      </div>
      <div className="box">
        <i onClick={scrollToBottom} class="fa-solid fa-phone"></i>
      </div>
    </div>
  );
};
